<template>
  <div v-if="hasAllPermissionsWithRequiredLevels">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { store } from '../../store'

const props = defineProps({
  permissions: {
    type: Array,
    required: true,
  },
})

defineEmits(['has-permissions'])

const clientSession = store.state.clientSession

const hasAllPermissionsWithRequiredLevels = computed(() => {
  if (!clientSession?.permissions) {
    return false
  }

  return props.permissions.every(([code, requiredLevel]) => {
    const userPermission = clientSession.permissions.find((p) => p.code === code)
    // Fail if the user doesn't have the permission type or if their access level is too low.
    return userPermission && userPermission.access >= requiredLevel
  })
})
</script>
